import React from 'react'
import { useParams } from 'react-router-dom'

import NotFound from 'pages/NotFound'
import AlertDescriptionForm from 'pages/shared/AlertDescriptionForm'

import { alertCodeDisplayValue, alertCodeRawValue } from 'helpers/alerts'

import { useStoreContext } from 'hooks/StoreContext'
import useAlertDescriptions from 'hooks/useAlertDescriptions'

import { LoadingSinglePanePage, SinglePanePage } from 'styles/shared'

const EditAlertDescription = () => {
  useAlertDescriptions()

  const { alertCode: alertCodeFromUrl } = useParams()

  const { alertDescriptions, areAlertDescriptionsLoaded } = useStoreContext()

  if (!areAlertDescriptionsLoaded) {
    return <LoadingSinglePanePage />
  }

  const alertDescription = alertDescriptions?.filter(
    (alert) => alert.code?.toUpperCase() === alertCodeRawValue(alertCodeFromUrl).toUpperCase()
  )[0]

  if (!alertDescription) {
    return <NotFound />
  }

  const alertDescriptionWithDisplayCode = {
    ...alertDescription,
    code: alertCodeDisplayValue(alertDescription.code)
  }

  return (
    <SinglePanePage>
      <AlertDescriptionForm
        title={`Edit Alert: ${alertDescriptionWithDisplayCode.code}`}
        alertDescription={alertDescriptionWithDisplayCode}
        saveMethod="update"
        displayDeleteButton
      />
    </SinglePanePage>
  )
}

export default EditAlertDescription
